<template>
  <a-modal
    :visible="visible"
    title="Switch site"
    :closable="false"
    @ok="setSite"
    @cancel="hideModal"
  >
    <form>
      <div class="row">
        <div class="col">
          <base-input label="Select site">
            <a-select v-model="selectedSiteId" @change="setSelectedSite">
              <a-select-option
                v-for="site in visitingSites"
                v-bind:value="site.id"
                v-bind:key="site.id"
              >
                {{ site.name }}
              </a-select-option>
            </a-select>
          </base-input>
        </div>
      </div>
    </form>
  </a-modal>
</template>
<script>
import secureStorage from '../../controllers/secureStorage';
import HTTPRequest from "@/controllers/httpRequest";

export default {
  name: 'SwitchSiteModal',
  props: {
    visible: Boolean,
    currentSite: Object
  },
  data() {
    return {
      selectedSite: null,
      selectedSiteId: null,
      visitingSites: []
    };
  },
  methods: {
    async getVisitingSites() {
      const data = await HTTPRequest.getRequest('/api/auth/users/me');
      const visitingSites = data.visiting_sites ?? [];
      this.visitingSites = visitingSites;
    },
    setSite() {
      this.$notification.success({
        message: 'Success',
        description: 'Current site has been updated.'
      });
      secureStorage.setItem('currentSite', this.selectedSite);
      secureStorage.setItem('currentSiteId', this.selectedSite.id);
      this.hideModal();
      setTimeout(() => {
        location.reload();
      }, 3000);
    },
    setSelectedSite(siteId) {
      let site = this.visitingSites.find(s => s.id == siteId);
      this.selectedSite = site;
    },

    hideModal() {
      this.$emit('hideModal', null);
    }
  },
  created() {
    this.getVisitingSites();
  }
};
</script>
